import React from 'react';
import { SvgIconProps } from '@mui/material';

export const ContactCalendarIcon: React.FC<SvgIconProps> = (props) => (
    <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.11111 1V3.44444M18.8889 1V3.44444M5.08889 23H19.9111C21.3423 23 22.058 23 22.6047 22.7336C23.0855 22.4993 23.4765 22.1253 23.7214 21.6653C24 21.1425 24 20.4579 24 19.0889V7.35555C24 5.98653 24 5.30203 23.7214 4.77914C23.4765 4.31918 23.0855 3.94523 22.6047 3.71088C22.058 3.44444 21.3423 3.44444 19.9111 3.44444H5.08889C3.65765 3.44444 2.94202 3.44444 2.39536 3.71088C1.91449 3.94523 1.52354 4.31918 1.27854 4.77914C1 5.30203 1 5.98653 1 7.35555V19.0889C1 20.4579 1 21.1425 1.27854 21.6653C1.52354 22.1253 1.91449 22.4993 2.39536 22.7336C2.94202 23 3.65764 23 5.08889 23Z"
            stroke="currentColor"
            strokeWidth="1.656"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M16.2347 16.6743H8.7449C6.67665 16.6743 5 18.351 5 20.4192V22.2917H19.9796V20.4192C19.9796 18.351 18.3029 16.6743 16.2347 16.6743Z"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1777 14.4898C14.246 14.4898 15.9226 12.8131 15.9226 10.7449C15.9226 8.67665 14.246 7 12.1777 7C10.1095 7 8.43282 8.67665 8.43282 10.7449C8.43282 12.8131 10.1095 14.4898 12.1777 14.4898Z"
            stroke="currentColor"
            strokeWidth="1.3"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default ContactCalendarIcon;
